import { render, staticRenderFns } from "./SlideCarousel.vue?vue&type=template&id=39807214"
import script from "./SlideCarousel.vue?vue&type=script&lang=js"
export * from "./SlideCarousel.vue?vue&type=script&lang=js"
import style0 from "./SlideCarousel.vue?vue&type=style&index=0&id=39807214&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports